export default [
  {
    name: 'base',
    data: {},
    items: [
      { name: 'noise', source: '/assets/noise.jpg', type: 'texture' },
      { name: 'testnoise', source: '/assets/testnoise.jpg', type: 'texture' },
      { name: 'veiny', source: '/assets/veiny.jpg', type: 'texture' },
      { name: 'whiteMat', source: '/assets/whiteMat.png', type: 'texture' },
      { name: 'greyNoise', source: '/assets/greyNoise.png', type: 'texture' },
      { name: 'laptopMask', source: '/assets/laptopMask.jpg', type: 'texture' },
      {
        name: 'silverMatCap',
        source: '/assets/silverMatCap.jpg',
        type: 'texture'
      },
      {
        name: 'blueMatCap',
        source: '/assets/blueMatCap.jpg',
        type: 'texture'
      },
      {
        name: 'blackMatCap',
        source: '/assets/blackMatCap.jpg',
        type: 'texture'
      },

      //progjects
      { name: 'cantine', source: '/assets/cantine.jpg', type: 'texture' },
      { name: 'daPortal', source: '/assets/daPortal.jpg', type: 'texture' },
      { name: 'scrimba', source: '/assets/scrimba.jpg', type: 'texture' },

      //models
      {
        name: 'dungeonModel',
        source: '/assets/portal/animsFactoryJoinTest.glb'
      },
      {
        name: 'animsModel',
        source: '/assets/portal/animsFactory.glb'
      },

      // screen Textures

      {
        name: 'githubIconTexture',
        source: '/assets/githubIcon.jpg',
        type: 'texture'
      },
      {
        name: 'javascriptIconTexture',
        source: '/assets/javascriptIcon.jpg',
        type: 'texture'
      },
      {
        name: 'htmlIconTexture',
        source: '/assets/htmlIcon.jpg',
        type: 'texture'
      },
      {
        name: 'cssIconTexture',
        source: '/assets/cssIcon.jpg',
        type: 'texture'
      },
      {
        name: 'reactIconTexture',
        source: '/assets/reactIcon.jpg',
        type: 'texture'
      },
      {
        name: 'npmIconTexture',
        source: '/assets/npmIcon.jpg',
        type: 'texture'
      },
      {
        name: 'figmaIconTexture',
        source: '/assets/figmaIcon.jpg',
        type: 'texture'
      },
      {
        name: 'threeIconTexture',
        source: '/assets/threeIcon.jpg',
        type: 'texture'
      },
      {
        name: 'blenderIconTexture',
        source: '/assets/blenderIcon.jpg',
        type: 'texture'
      },

      //baked Textures
      {
        name: 'bakedFactory',
        source: '/assets/factory-main-bake.jpg',
        type: 'texture'
      },
      {
        name: 'factoryOutsideWalls',
        source: '/assets/factory-outside-walls.jpg',
        type: 'texture'
      },
      {
        name: 'bakedFloor',
        source: '/assets/factory-floor-bake.jpg',
        type: 'texture'
      },
      {
        name: 'bakedSign',
        source: '/assets/main-sing-bake.jpg',
        type: 'texture'
      },
      {
        name: 'logo',
        source: '/assets/dfdFilledinverted.png',
        type: 'texture'
      },
      {
        name: 'blenderBake',
        source: '/assets/blenderBake.jpg',
        type: 'texture'
      },
      {
        name: 'htmlbake',
        source: '/assets/htmlbake.jpg',
        type: 'texture'
      },
      {
        name: 'cssBake',
        source: '/assets/cssBake.jpg',
        type: 'texture'
      },
      {
        name: 'figmaBake',
        source: '/assets/figmaBake.jpg',
        type: 'texture'
      },
      {
        name: 'jsBake',
        source: '/assets/jsBake.jpg',
        type: 'texture'
      },
      {
        name: 'mobileIconsBake',
        source: '/assets/mobileIconsBake.jpg',
        type: 'texture'
      }

      //   {
      //     name: 'leftWall',
      //     source: '/assets/leftWallFinall80.jpg',
      //     type: 'texture'
      //   },
      //   {
      //     name: 'rightWall',
      //     source: '/assets/rightWallFinall80.jpg',
      //     type: 'texture'
      //   },
      //   {
      //     name: 'portals',
      //     source: '/assets/portalsFinall80.jpg',
      //     type: 'texture'
      //   },
      //   { name: 'floor', source: '/assets/finallFloor80.jpg', type: 'texture' },
      //   { name: 'bridge', source: '/assets/testBridge.jpg', type: 'texture' },
      //   { name: 'stairs', source: '/assets/stairsFinall80.jpg', type: 'texture' },
      //   {
      //     name: 'details',
      //     source: '/assets/detailsFinall80.jpg',
      //     type: 'texture'
      //   },
      //   { name: 'flag', source: '/assets/flag.jpg', type: 'texture' }
    ]
  }
];
